import Util from '@/util';
/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */


const theState = {
    email: '',
    gpnumber: '',
    loading: false,
    result: [],
    emptyResultMessage: '',
    resultTitle: '',
};

const getters = {};

const actions = {
    search({ commit, state }, payload) {
        commit('search', payload);
        return new Promise((resolve, reject) => {
            let gp = state.gpnumber;
            if (gp.length >= 7 && gp.length <= 9) {
                const prefix = '0'.repeat(10 - gp.length);
                gp = `${prefix}${gp}`;
            }
            commit('updateGpnumber', gp);
            commit('updateResultTitle');
            Api.search.simpleSearch(state.email, gp)
                .then(({ data }) => {
                    commit('searchSuccess', data);
                    resolve();
                    /* eslint-disable-next-line */
                }).catch((response) => {
                    commit('searchFailure');
                    reject();
                });
        });
    },
    reloadResult({ commit, state }) {
        commit('reloadResult');
        Api.search.simpleSearch(state.email, state.gpnumber)
            .then(({ data }) => {
                commit('searchSuccess', data);
                /* eslint-disable-next-line */
            }).catch((response) => {
                commit('searchFailure');
            });
    },
    searchInvisible({ commit }, payload) {
        return new Promise((resolve, reject) => {
            let gp = payload.gpnumber;
            if (gp.length >= 7 && gp.length <= 9) {
                const prefix = '0'.repeat(10 - gp.length);
                gp = `${prefix}${gp}`;
            }
            Api.search.simpleSearch(payload.email, gp)
                .then(({ data }) => {
                    if (data.c1.data.length === 1) {
                        resolve({
                            ssoId: data.c1.data[0].user_id,
                            multibleResults: false,
                        });
                    } else if (data.c1.data.length > 1) {
                        commit('search', payload);
                        commit('searchSuccess', data);
                        resolve({
                            ssoId: undefined,
                            multibleResults: true,
                        });
                    } else {
                        resolve({
                            ssoId: undefined,
                            multibleResults: false,
                        });
                    }
                    /* eslint-disable-next-line */
                }).catch((response) => {
                    reject();
                });
        });
    },
};

const mutations = {
    /* eslint-disable no-param-reassign */
    updateEmail(state, value) {
        state.email = value;
    },
    updateGpnumber(state, value) {
        state.gpnumber = value;
    },
    clear(state) {
        state.email = '';
        state.gpnumber = '';
    },
    reloadResult(state) {
        state.loading = true;
        state.result = [];
        state.emptyResultMessage = '';
    },
    updateResultTitle(state) {
        if (state.email.length > 0 && state.gpnumber.length > 0) {
            state.resultTitle = `Suchergebnisse für "${state.email}" und "${state.gpnumber}"`;
        } else if (state.email.length > 0) {
            state.resultTitle = `Suchergebnisse für "${state.email}"`;
        } else if (state.gpnumber.length > 0) {
            state.resultTitle = `Suchergebnisse für "${state.gpnumber}"`;
        } else {
            state.resultTitle = '';
        }
    },
    search(state, { email, gpnumber }) {
        state.email = email || '';
        state.email = state.email.trim();
        state.gpnumber = gpnumber || '';
        state.gpnumber = state.gpnumber.trim();
        state.loading = true;
        state.result = [];
        state.emptyResultMessage = '';
    },
    searchSuccess(state, data) {
        state.loading = false;
        if (data.c1.status === 'ok') {
            state.result = data.c1.data.map((customer) => {
                const mhnIds = Object.keys(customer.msp.MHN).length ? customer.msp.MHN : {};
                const nozIds = Object.keys(customer.msp.NOZ).length ? customer.msp.NOZ : {};
                const gpIds = [
                    ...Object.keys(mhnIds).map(key => ({
                        id: key,
                        scope: 'MHN',
                    })),
                    ...Object.keys(nozIds).map(key => ({
                        id: key,
                        scope: 'NOZ',
                    })),
                ];
                const gpIdsAsString = gpIds.map(gp => `${gp.id} (${gp.scope})`).join(', ');
                return {
                    existInC1: true,
                    gpIds,
                    gpIdsAsString,
                    ssoId: customer.user_id,
                    login: customer.login,
                    sapMail: [{
                        scope: 'celeraone',
                        mail: customer.login,
                    }],
                    sapData: [],
                    createdAt: customer.info.creation_time ? Util.formatTimestamp(customer.info.creation_time) : '-',
                    lastLogin: customer.info.login_time ? Util.formatTimestamp(customer.info.login_time) : '-',
                    accountState: customer.info.account_state,
                    name: `${(customer.masterdata.title || '')} ${(customer.masterdata.first_name || '')} ${(customer.masterdata.last_name || '')}`
                        .trim()
                        .replace(/ {2,}/, ' '),
                };
            });
        }
        const msp = data.msp.data;
        state.result = state.result.map((result) => {
            if (result.gpIds.find(gpId => gpId.id === state.gpnumber) && data.msp.status === 'ok') {
                return {
                    ...result,
                    sapMail: [
                        ...result.sapMail,
                        ...Object.keys(msp).map((key) => {
                            if (msp[key]) {
                                return {
                                    scope: key,
                                    mail: msp[key].email,
                                };
                            }
                            return null;
                        }).filter(value => !!value),
                    ],
                    sapData: [
                        ...result.sapData,
                        ...Object.keys(msp).map((key) => {
                            if (msp[key]) {
                                return {
                                    gpnumber: state.gpnumber,
                                    scope: key,
                                    data: msp[key],
                                };
                            }
                            return null;
                        }).filter(value => !!value),
                    ],
                };
            }
            return result;
        });
        if (!state.result.filter(result => !!result.sapData).length && data.msp.status === 'ok') {
            state.result = [
                ...state.result,
                ...Object.keys(msp).map((key) => {
                    if (msp[key]) {
                        return {
                            existInC1: false,
                            gpIds: [{ id: state.gpnumber, scope: key }],
                            gpIdsAsString: `${state.gpnumber} (${key})`,
                            createdAt: '-',
                            lastLogin: '-',
                            accountState: 'exist_not_in_c1',
                            ssoId: '',
                            login: msp[key].email,
                            sapMail: [{
                                scope: key,
                                mail: msp[key].email,
                            }],
                            sapData: [{
                                gpnumber: state.gpnumber,
                                scope: key,
                                data: msp[key],
                            }],
                            name: `${(msp[key].anrede)} ${(msp[key].title || '')} ${(msp[key].vorname || '')} ${(msp[key].nachname || '')}`
                                .trim()
                                .replace(/ {2,}/, ' '),
                        };
                    }
                    return null;
                }).filter(value => !!value),
            ];
        }
        if (!state.result.length) {
            state.emptyResultMessage = 'Die Suche hat keine Ergebnisse geliefert.';
        }
        state.result = state.result.map((customer, index, allCustomers) => {
            // neues Array nur mit den gpIds erstellen;
            const allCustomersGpIds = allCustomers
                .map(c => c.gpIds);
            // aktuellen Kunden aus dem neuen Array entfernen
            allCustomersGpIds.splice(index, 1);
            // Nach Duplikaten suchen
            const deletable = allCustomersGpIds
                .findIndex(gpIds => gpIds.some(gpId => customer.gpIds.find(element => element.id === gpId.id))) > -1;
            return {
                ...customer,
                deletable,
            };
        });
    },
    searchFailure(state) {
        state.loading = false;
        state.result = [];
        state.emptyResultMessage = 'Bei der Suche ist ein unbekannter Fehler aufgetreten.';
    },
    /* eslint-enable no-param-reassign */
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
